import { Pipe, PipeTransform } from '@angular/core';
import { ArticleClassificationType } from 'aa-ng';
import { ActivityType } from 'src/app/models';

@Pipe({ name: 'activityTypeTitle' })
export class ResearchAtAGlanceActivityTypeTitlePipe implements PipeTransform {
  transform(
    value: ActivityType,
    subtype?: ArticleClassificationType,
    short = true,
  ): string {
    switch (value) {
      case ActivityType.Article:
        switch (subtype) {
          case ArticleClassificationType.Unknown:
          case ArticleClassificationType.NonResearch:
          case ArticleClassificationType.Law:
            return 'Other';
          case ArticleClassificationType.BookReview:
            return 'Book Review';
        }
        return 'Articles';
      case ActivityType.Award:
        return short ? 'Awards' : 'Honorific Awards';
      case ActivityType.Book:
        return 'Books';
      case ActivityType.ClinicalTrial:
        return 'Clinical Trials';
      case ActivityType.ConferenceProceeding:
        return 'Conference Proceedings';
      case ActivityType.Exhibit:
        return 'Exhibits & Installations';
      case ActivityType.Grant:
        return 'Grants';
      case ActivityType.LiteraryWork:
        return 'Literary & Critical Works';
      case ActivityType.OtherCreativeWork:
        return 'Creative Works';
      case ActivityType.Patent:
        return 'Patents';
      case ActivityType.Presentation:
        return 'Presentations';
      case ActivityType.Performance:
        return 'Performances';
      case ActivityType.Production:
        return 'Productions';
      case ActivityType.BookChapter:
        return 'Book Chapters';
      case ActivityType.ClassroomEducationalMaterials:
        return 'Classroom Educational Materials';
      case ActivityType.OnlineEducationalMaterials:
        return 'Online Educational Materials';
      case ActivityType.EducationalMaterials:
        return 'Educational Materials';
      case ActivityType.SoftwareDigitalMedia:
        return 'Software & Digital Media';
      case ActivityType.Media:
        return 'Media';
      case ActivityType.OtherContent:
        return 'Other';
      case ActivityType.OtherIntellectualProperty:
        return 'Intellectual Properties';
      case ActivityType.Reviewer:
        return 'Reviews';
      case ActivityType.CommunityEngagement:
        return 'Community Engagement';
      case ActivityType.ResearchDataSet:
        return short ? 'Data Sets' : 'Research Data Sets';
      case ActivityType.FieldResearch:
        return short ? 'Research Projects' : 'Field Research Projects';
      case ActivityType.Project:
        return 'Special Projects';
      case ActivityType.Technology:
        return short ? 'Technologies' : 'Technologies for Licensing';
      default:
        return '';
    }
  }
}
